/* Hero Split Slider Component JavaScript */

(function(){
  // locate this section element without relying on Liquid interpolation
  const sectionEl = (function(){
    if (document.currentScript && document.currentScript.closest) {
      const sec = document.currentScript.closest('section.mt-hero-split-slider');
      if (sec) return sec;
    }
    return document.querySelector('section.mt-hero-split-slider');
  })();
  if (!sectionEl) return;

  const rightCol = sectionEl.querySelector('.mt-hero-split-slider__col--right');
  const leftTrack = sectionEl.querySelector('.mt-hero-split-slider__left-track');
  const leftSlides = Array.from(sectionEl.querySelectorAll('.mt-hero-split-slider__slide-left'));
  const rightSlides = Array.from(sectionEl.querySelectorAll('.mt-hero-split-slider__slide-right'));
  const prevBtn = sectionEl.querySelector('.mt-hero-split-slider__arrow--prev');
  const nextBtn = sectionEl.querySelector('.mt-hero-split-slider__arrow--next');
  const progressInner = sectionEl.querySelector('.mt-hero-split-slider__progress-inner');

  let index = 0;
  const total = Math.max(leftSlides.length, rightSlides.length);
  let lastDirection = 'next';

  // if no slides, hide controls
  if (total <= 1) {
    sectionEl.querySelectorAll('.mt-hero-split-slider__controls').forEach(el => el.style.display = 'none');
  }

  // initialize active states
  function init() {
    // set initial active classes for images (use opacity)
    leftSlides.forEach(slide => {
      const img = slide.querySelector('.mt-hero-split-slider__img');
      if (!img) return;
      if (Number(slide.dataset.index) === index) {
        img.classList.add('is-active');
      } else {
        img.classList.remove('is-active');
      }
    });

    // set progress inner width (bright block width) equal partition of whole
    if (progressInner && total > 0) {
      const brightWidthPercent = 100 / total;
      progressInner.style.width = brightWidthPercent + '%';
    }

    // set initial right column background and text color from the first slide (if present)
    if (rightCol && rightSlides[index]) {
      const bg = rightSlides[index].dataset.rightBg;
      const txt = rightSlides[index].dataset.rightText;
      if (bg) rightCol.style.background = bg;
      if (txt) rightCol.style.color = txt;
    }

    updateUI(true);
  }

  function updateUI(initial, direction = 'next') {
    // Left translate: move track by -index * 100%
    leftTrack.style.transform = 'translateY(' + (-index * 100) + '%)';

    // Left images crossfade (toggle is-active on image elements)
    leftSlides.forEach(slide => {
      const img = slide.querySelector('.mt-hero-split-slider__img');
      const idx = Number(slide.dataset.index);
      if (!img) return;
      if (idx === index) img.classList.add('is-active'); else img.classList.remove('is-active');
    });

    // Right fade + text fade entrance + update right column background
    rightSlides.forEach(slide => {
      const idx = Number(slide.dataset.index);
      if (idx === index) {
        // update right column background and text color to this slide's settings
        if (rightCol) {
          const bg = slide.dataset.rightBg;
          const txt = slide.dataset.rightText;
          if (bg) rightCol.style.background = bg;
          if (txt) rightCol.style.color = txt;
        }

        // activate: fade in text elements. same for initial and subsequent changes.
        slide.classList.add('is-active');
      } else {
        slide.classList.remove('is-active','enter-next','enter-prev');
      }
    });

    // Meta fade like images: toggle class on .mt-hero-split-slider__meta inside slides
    rightSlides.forEach(slide => {
      const meta = slide.querySelector('.mt-hero-split-slider__meta');
      if (!meta) return;
      const idx = Number(slide.dataset.index);
      if (idx === index) meta.classList.add('is-active'); else meta.classList.remove('is-active');
    });

    // Progress bright block movement: equal partitions
    if (progressInner && total > 0) {
      const brightWidthPercent = 100 / total; // 亮块宽度百分比
      // 每次移动的距离应该是整个进度条的 1/total
      // translateX 的百分比是相对于元素自身宽度，所以需要转换
      // 由于亮块宽度已经是 100/total %，移动 index 个单位就是 index * (100/total) % of outer container
      // 相对于自身宽度 (100/total %) 来说，就是 index * 100 %
      const translatePercent = index * 100; 
      progressInner.style.transform = 'translateX(' + translatePercent + '%)';
    }
  }

  function next() { 
    if (total <= 0) return; 
    index = (index + 1) % total; 
    lastDirection = 'next'; 
    updateUI(false, lastDirection); 
  }
  
  function prev() { 
    if (total <= 0) return; 
    index = (index - 1 + total) % total; 
    lastDirection = 'prev'; 
    updateUI(false, lastDirection); 
  }

  prevBtn && prevBtn.addEventListener('click', prev);
  nextBtn && nextBtn.addEventListener('click', next);

  // keyboard nav
  sectionEl.addEventListener('keydown', function(e){
    if (e.key === 'ArrowLeft') prev();
    if (e.key === 'ArrowRight') next();
  });

  // touch swipe (vertical)
  (function addSwipe(){
    let startY = null, startX = null;
    sectionEl.addEventListener('touchstart', function(e){
      const t = e.touches[0];
      startY = t.clientY;
      startX = t.clientX;
    }, {passive:true});
    sectionEl.addEventListener('touchend', function(e){
      if (startY === null) return;
      const t = e.changedTouches[0];
      const dy = t.clientY - startY;
      const dx = t.clientX - startX;
      if (Math.abs(dy) > 40 && Math.abs(dy) > Math.abs(dx)) {
        if (dy < 0) { next(); } else { prev(); }
      }
      startY = null;
      startX = null;
    }, {passive:true});
  })();

  init();
})();
